import Abstract from "../../abstract-view/abstract.js";

export default class BreadcrumbsList extends Abstract {
  constructor(element) {
    super();

    this._element = element;
  }

  getItems() {
    return this._element.querySelectorAll(`li`);
  }

  getInnerWidth() {
    const styles = window.getComputedStyle(this._element);

    return this._element.offsetWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
  }
}
